module.exports = __webpack_public_path__ + "img/helena.0875e821.png";